/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetUserDocumentItem200ResponseData } from './GetUserDocumentItem200ResponseData'
import {
  GetUserDocumentItem200ResponseDataFromJSON,
  GetUserDocumentItem200ResponseDataFromJSONTyped,
  GetUserDocumentItem200ResponseDataToJSON,
} from './GetUserDocumentItem200ResponseData'

/**
 *
 * @export
 * @interface GetUserDocumentItem200Response
 */
export interface GetUserDocumentItem200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetUserDocumentItem200Response
   */
  status: boolean
  /**
   *
   * @type {GetUserDocumentItem200ResponseData}
   * @memberof GetUserDocumentItem200Response
   */
  data: GetUserDocumentItem200ResponseData
}

/**
 * Check if a given object implements the GetUserDocumentItem200Response interface.
 */
export function instanceOfGetUserDocumentItem200Response(
  value: object
): value is GetUserDocumentItem200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetUserDocumentItem200ResponseFromJSON(
  json: any
): GetUserDocumentItem200Response {
  return GetUserDocumentItem200ResponseFromJSONTyped(json, false)
}

export function GetUserDocumentItem200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetUserDocumentItem200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetUserDocumentItem200ResponseDataFromJSON(json['data']),
  }
}

export function GetUserDocumentItem200ResponseToJSON(
  value?: GetUserDocumentItem200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetUserDocumentItem200ResponseDataToJSON(value['data']),
  }
}
